import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { State } from '@/store';

export const useAppSelector: TypedUseSelectorHook<State> = useSelector;
